import * as React from 'react';

export const TempusNextLogo = (props: React.SVGProps<SVGSVGElement>) => {
  const title = 'Tempus Next';

  return (
    <svg
      aria-labelledby={title}
      role="img"
      width="173"
      height="48"
      viewBox="0 0 173 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{title}</title>
      <path
        d="M35.8373 28.2261V31.1439H25.0891V18.8056H35.7337V21.7072H28.6545V23.4009H35.1896V26.3738H28.6545V28.2261H35.8373Z"
        fill="black"
      />
      <path
        d="M54.782 18.8056V31.1439H51.2521V24.5376L48.7164 31.1439H44.785L42.2493 24.5376V31.1439H38.7195V18.8056H43.4929L46.7604 27.1413L50.028 18.8056H54.782Z"
        fill="black"
      />
      <path
        d="M63.8689 21.7072H61.3527V24.4696H63.9045C65.0218 24.4696 65.4946 24.1199 65.4946 23.09C65.4946 22.0602 64.9862 21.7105 63.8689 21.7105V21.7072ZM63.7977 27.3874H61.3494V31.1439H57.784V18.8056H63.8139C67.2401 18.8056 69.1281 20.3083 69.1281 23.0868C69.1281 25.8653 67.2239 27.3874 63.7977 27.3874Z"
        fill="black"
      />
      <path
        d="M71.4533 18.8056H75.0187V25.8653C75.0187 26.5454 75.2292 27.1413 75.6308 27.6659C76.0324 28.1905 76.7319 28.4528 77.6937 28.4528C78.6555 28.4528 79.3712 28.1905 79.7727 27.6659C80.1743 27.1413 80.3848 26.5487 80.3848 25.8653V18.8056H83.9503V25.603C83.9503 27.5947 83.3738 29.0649 82.2209 30.0073C81.0843 30.9496 79.5655 31.4224 77.6937 31.4224C75.8219 31.4224 74.303 30.9496 73.1664 30.0073C72.0297 29.0649 71.4533 27.5947 71.4533 25.603V18.8056Z"
        fill="black"
      />
      <path
        d="M87.1466 27.4392C87.6874 27.7015 88.3512 27.9476 89.1576 28.1549C89.9802 28.346 90.7477 28.4528 91.4828 28.4528C92.898 28.4528 93.5975 28.2261 93.5975 27.7728C93.5975 27.2643 92.8461 27.0215 91.4633 26.743C91.2723 26.7268 91.0618 26.6717 90.7995 26.6037C87.8979 25.9398 86.2722 25.1367 86.2204 22.4424C86.2204 21.1308 86.745 20.1528 87.8104 19.5051C88.8759 18.8574 90.2587 18.5271 91.9523 18.5271C93.646 18.5271 95.6927 18.9643 97.1079 19.7156L95.9712 22.3193C94.6953 21.8109 93.0534 21.5162 91.8649 21.5162C90.5534 21.5162 89.8215 21.7947 89.8215 22.2869C89.8215 22.7792 90.521 23.0026 91.7969 23.2293L92.3053 23.3329C93.8598 23.6665 95.0677 24.1199 95.9226 24.7319C96.7776 25.3278 97.2147 26.2183 97.2147 27.4068C97.2147 28.754 96.6739 29.7676 95.5891 30.4315C94.5074 31.0954 93.089 31.4289 91.3435 31.4289C90.4011 31.4289 89.4393 31.3059 88.4581 31.0436C87.4801 30.7812 86.6414 30.4477 85.9581 30.0299L87.1466 27.4425V27.4392Z"
        fill="black"
      />
      <path d="M8 21.6878H9.5771V18.8056H8V21.6878Z" fill="black" />
      <path d="M10.4158 21.6878H13.298V18.8056H10.4158V21.6878Z" fill="black" />
      <path d="M14.4898 31.1439H18.0552V21.6878H20.0987V18.8056H14.4898V31.1439Z" fill="black" />
      <path d="M20.9374 18.8056V21.6878H22.1259V18.8056H20.9374Z" fill="black" />
      <path d="M158.771 31.1381V20.5713H155.096V18.8043H164.444V20.5713H160.768V31.1381H158.771Z" fill="black" />
      <path
        d="M141.646 31.1381L145.639 24.8299L141.787 18.8043H144.137L146.947 23.3986H146.982L149.827 18.8043H152.036L148.148 24.8122L152.195 31.1381H149.845L146.859 26.2258H146.806L143.855 31.1381H141.646Z"
        fill="black"
      />
      <path
        d="M138.107 31.1381H130.208V18.8043H138.107V20.5713H132.205V23.9994H137.559V25.7664H132.205V29.3711H138.107V31.1381Z"
        fill="black"
      />
      <path
        d="M122.833 31.1381L118.804 24.3174L117.444 21.7022H117.391V31.1381H115.482V18.8043H117.709L121.738 25.625L123.098 28.2402H123.151V18.8043H125.06V31.1381H122.833Z"
        fill="black"
      />
      <path d="M105.535 34V16H106.906V34H105.535Z" fill="black" />
    </svg>
  );
};

export default TempusNextLogo;
